// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3LzQZ","header":"PatientQuestionnaire_header__xGlJY","info":"PatientQuestionnaire_info__1lfWj"};